import {
  Button,
  CloseButton,
  HStack,
  Link as ChakraLink,
  Text,
} from "@chakra-ui/react";
import React from "react";
import useKubuBanner from "../../globalState/useKubuBanner";

export default function HeroBanner() {
  const { show, setShow } = useKubuBanner();

  return (
    <HStack
      id="heroBanner"
      w={"100%"}
      minH={"60px"}
      justify={"center"}
      p={4}
      bg={"p.100"}
      display={show ? "flex" : "none"}
      gap={4}
    >
      <HStack ml={"auto"}>
        <Text>
          Gabung komunitas online untuk pekerja & calon pekerja di{" "}
          <b>Kubu.id</b>
        </Text>

        <Button
          flexShrink={0}
          variant={"outline"}
          colorScheme="ap"
          as={ChakraLink}
          href={
            "https://play.google.com/store/apps/details?id=com.kubu.id&pli=1"
          }
          isExternal
        >
          Download
        </Button>
      </HStack>

      <CloseButton
        _hover={{ bg: "p.100" }}
        ml={"auto"}
        onClick={() => {
          setShow(false);
        }}
      />
    </HStack>
  );
}
